import { createFileRoute, useRouter } from "@tanstack/react-router";
import { z } from "zod";
import HelpCircle from "@repo/icons/default/HelpCircle";
import Left from "@repo/icons/default/Left";
import { Billing } from "@/components/billing/billing";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";

import type { JSX } from "react";

const billingSearchParamsSchema = z.object({
  action: z.string().optional(),
  selectedFilter: z.string().optional(),
  selectedDate: z.string().optional(),
});

export type BillingSearchParams = z.infer<typeof billingSearchParamsSchema>;

const BillingPage = (): JSX.Element => {
  const router = useRouter();
  const handleAbout = (): void => {
    void router.navigate({ to: "/settings/billing/about" });
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Histórico de uso" align="center" />
        <HeaderButton icon={HelpCircle} onClick={handleAbout} align="end" />
      </HeaderRoot>
      <Page>
        <Billing />
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/billing/")({
  component: BillingPage,
  validateSearch: billingSearchParamsSchema,
});
